import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'footer-share',
  templateUrl: './footer-share.component.html',
  styleUrls: ['./footer-share.component.css']
})
export class FooterShareComponent implements OnInit {

  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  openPersonal(type) {
    this.router.navigateByUrl(`/terms?type=${type}`);
  }

}
